export default __webpack_public_path__ + "static/air_curtain_b.bf8bf49a0a9962ad6950290d75969dd8.png";